export { default as SimpleTextEditor } from './SimpleTextEditor';
